import { render, staticRenderFns } from "./OrangeCalloutRSI.vue?vue&type=template&id=49667e5d&scoped=true"
import script from "./OrangeCalloutRSI.vue?vue&type=script&lang=js"
export * from "./OrangeCalloutRSI.vue?vue&type=script&lang=js"
import style0 from "./OrangeCalloutRSI.vue?vue&type=style&index=0&id=49667e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49667e5d",
  null
  
)

export default component.exports